import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormRoutingModule } from './form-routing.module';
import { FormComponent } from './form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { AutocompleteLibModule} from 'angular-ng-autocomplete';

@NgModule({
    declarations: [FormComponent],
    imports: [
        CommonModule,
        FormRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        AutocompleteLibModule
    ]
})
export class FormModule { }
